import { createContext } from 'react';

import { DEFAULT_TRUNCATION_MODE } from '../../../../constants.js';
import { LegendState } from '../../categorical/types/legend-internal.js';

/**
 * @internal
 */
export const LegendContext = createContext<LegendState>({
  hiddenItems: new Set([]),
  truncationMode: DEFAULT_TRUNCATION_MODE,
  onLegendIconClick: () => undefined,
  onItemHover: () => undefined,
  onLegendNameClick: () => undefined,
  interactionsDisabled: false,
});

LegendContext['displayName'] = 'LegendContext';
